import * as React from 'react';
import { Tooltip, Box } from "@mui/material";
import { HelpOutlineIcon as HelpOutline } from "../../../icons";
type FieldHelpIconProps = {
  description: string;
};

export const FieldHelpIcon: React.FC<FieldHelpIconProps> = ({ description }) => {
  return (
    <Tooltip
      title={description}
      arrow
      placement="top"
      slotProps={{
        tooltip: {
          sx: { maxWidth: 300 }
        }
      }}
    >
      <HelpOutline
        sx={{
          fontSize: 16,
          color: 'action.active',
          cursor: 'help',
          ml: 0.5,
          verticalAlign: 'middle'
        }}
      />
    </Tooltip>
  );
};

type FieldLabelWithHelpProps = {
  label: React.ReactNode;
  description?: string;
};

export const FieldLabelWithHelp: React.FC<FieldLabelWithHelpProps> = ({ label, description }) => {
  if (!description) return <>{label}</>;

  // Si no hay label, solo mostrar el icono
  if (!label) {
    return <FieldHelpIcon description={description} />;
  }

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
      {label}
      <FieldHelpIcon description={description} />
    </Box>
  );
};
